import { Skeleton } from '@/shared/ui';

/** Lightweight skeleton shown while a lazily-loaded page chunk resolves. */
export function RouteFallback() {
  return (
    <div className="mx-auto w-full max-w-[1440px] space-y-6 px-6 py-6">
      <Skeleton className="h-8 w-56" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-28" />
        ))}
      </div>
      <Skeleton className="h-80" />
    </div>
  );
}
